import { Directive } from '@angular/core';

@Directive({
  selector: '[redPageLayoutContent],red-page-layout-content',
  host: {
    class: 'red-page-layout-content'
  }
})
export class PageLayoutContentDirective {

  constructor() { }

}
